import {
  broadcast,
  subscribe,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

import { IEvent as ICalendarEvent } from 'APP/model/calendar/calendar.types';

const CREATE_CALENDAR_EVENT_BUS_STATION = 'create-calendar-event';

export const subscribeCreateCalendarEvent = (
  callback: TEventSubscribeHandler
): TEventUnsubscribeHandler => {
  return subscribe(CREATE_CALENDAR_EVENT_BUS_STATION, callback);
};

export const broadcastCreateCalendarEvent = (event: ICalendarEvent): void => {
  broadcast(CREATE_CALENDAR_EVENT_BUS_STATION, event);
};
